import { useState } from 'react';
import styles from './CrmConnect.module.scss';
import { useNavigate } from 'react-router-dom';
import { Flex, Spin } from 'antd';
import CustomButton from '../../../components/UI/CustomButton/CustomButton';
import { CrmOption } from './CrmOption';
import { useGetCrmsQuery } from '../../../redux/API/CrmSlice';
import type { CrmItem } from '../../../redux/API/CrmSlice';

export const CrmConnect = () => {
  const navigate = useNavigate();
  const { data: crmList, isLoading } = useGetCrmsQuery();
  const [selectedCrm, setSelectedCrm] = useState<CrmItem | null>(null);
  const [isDisable, setisDisable] = useState(true);

  const handleNext = () => {
    if (!selectedCrm) return;

    //window.open(selectedCrm.tutorialUrl, '_blank');

    window.open(selectedCrm.loginUrl, '_blank');
    navigate('/crm/token', { state: selectedCrm });
  };

  return (
    <Flex vertical className={styles.crmConnect}>
      <p className={styles.title}>Choose a CRM system from which you want to import customers</p>

      {isLoading ? (
        <Spin className={styles.spin} />
      ) : (
        <Flex vertical className={styles.list}>
          {crmList?.map((crm) => (
            <CrmOption
              key={crm.name}
              label={crm.name}
              isActive={selectedCrm?.name === crm.name}
              onClick={() => {
                setisDisable(false);
                setSelectedCrm(crm);
              }}
            />
          ))}
          {selectedCrm?.tutorialUrl && (
            <Flex style={{ width: '100%' }}>
              <a
                href={selectedCrm.tutorialUrl}
                target="_blank"
                rel="noopener noreferrer"
                className={styles.crmConnect__helpLink}
              >
                Where to find your JobNimbus API key?
              </a>
            </Flex>
          )}
        </Flex>
      )}

      <Flex className={styles.nextButtonWrapper}>
        <CustomButton text={'Next'} disable={isDisable} onClick={() => handleNext()} />
      </Flex>
    </Flex>
  );
};
